import { assignSafe, SDate } from '@summit/core';
import { Dayjs } from 'dayjs';

export class IntegrationConfiguration {
  refNumber: number;
  lastLocationPacketId: number;
  lastHosPacketId: number;
  lastHosRead: Dayjs; //UTC
  lastLocationRead: Dayjs; //UTC

  constructor(jsonData?: Partial<IntegrationConfiguration>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.lastHosRead) this.lastHosRead = SDate.newUtc(jsonData.lastHosRead);
      if (jsonData.lastLocationRead) this.lastLocationRead = SDate.newUtc(jsonData.lastLocationRead);
    }
  }
}
